import { EventQBus } from '../types/global';
import { ContentTracking } from './content-tracking';

export class Tracking {
    private readonly eventQBus: EventQBus;
    public visibilityTracked = false;

    //accessible for testing
    contentTracking: ContentTracking | null = null;

    constructor(eventQBus?: EventQBus | null) {
        this.eventQBus = eventQBus || o_global.eventQBus;
    }

    public init(): void {
        this.registerVisibilityTrackingListener();

        this.eventQBus.on('ft5.richContent.variationChanged', ({ variationId, isInitialVariationChange }) => {
            const richContentElement = document.querySelector<HTMLElement>('.js_rc_component');
            if (richContentElement) {
                this.contentTracking = new ContentTracking(this.eventQBus, richContentElement, variationId || 'missing');
                if (isInitialVariationChange) {
                    this.contentTracking.trackPageImpression();
                }
            } else {
                this.contentTracking = null;
            }
        });
    }

    private registerVisibilityTrackingListener(): void {
        const relevantEvents = ['scroll', 'resize'];
        relevantEvents.forEach((type) => {
            addEventListener(type, () => this.contentTracking?.trackRichContentVisibleIfRequired(), false);
        });
    }
}
